import { ref, onMounted, onUnmounted } from "vue";

export function useDevice() {
  const isMobile = ref(false);

  let mediaQuery;

  const updateDevice = () => {
    isMobile.value = mediaQuery.matches;
  };

  onMounted(() => {
    mediaQuery = window.matchMedia("(max-width: 768px)"); // Puedes ajustar el breakpoint
    updateDevice();
    mediaQuery.addEventListener("change", updateDevice);
  });

  onUnmounted(() => {
    mediaQuery.removeEventListener("change", updateDevice);
  });
  // return {'hello': isMobile
  // };
  return {
    isMobile
  };
}